export default __webpack_public_path__ + "static/media/personalize_and_customize.70850629.gif";